<template>
	<div class="danger">
		<van-cell-group class="navShow">
			<van-row>
				<van-col :span="3" style='font-size:.6rem;position:relative;top:3px;'>
					<van-icon name="arrow-left" color="#fff" @click="goBack" />
				</van-col>
				<van-col v-if='gcName' :span="18">{{gcName}}</van-col>
				<van-col v-else :span="18">{{name}}</van-col>
				<van-col :span="2"></van-col>
			</van-row>
		</van-cell-group>
		<van-row class="elRow" v-show="!show">
			<van-col class="elCol" :span="24" v-show='chartsState == 1'>
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/info1.png" alt="">
						<span>基本情况</span>
					</div>
					<div class="colContent">
						<van-col :span='12'>
							<span class='num num1'>{{info.num}}</span><br>
							<span>总数</span>
						</van-col>
						<van-col :span='12'>
							<span class='num num4'>{{info.num1}}</span><br>
							<span>合规率</span>
						</van-col>
						<!-- <van-col :span='8'>
							<span class='num num3'>{{info.num2}}</span><br>
							<span>不合规率</span>
						</van-col> -->
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 1'>
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon2.png" alt="">
						<span>问题类别</span>
					</div>
					<div class="colContent">
						<van-col :span='8' class='typeBox' v-for="(item,index) in typeList">
							<div> <span class='num'>{{item.value}}</span><br> <span>{{item.name}}</span> </div>
						</van-col>
						<!-- <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num2}}</span><br> <span>作业确认</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num3}}</span><br> <span>作业类别</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num4}}</span><br> <span>作业级别</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num5}}</span><br> <span>作业资质</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num6}}</span><br> <span>安全交底</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num7}}</span><br> <span>安全分析</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num8}}</span><br> <span>气体检测</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num9}}</span><br> <span>相关方</span> </div>
            </van-col>
            <van-col :span='8' class='typeBox'>
              <div> <span class='num'>{{typeList.num10}}</span><br> <span>视频记录</span> </div>
            </van-col> -->
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 2' style="height:42.5%">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon1.png" alt="">
						<span>上月合规率
							<!-- <strong>({{ complianceRate }}%)</strong> --></span>
					</div>
					<div class="colContent">
						<gaugeChart :receiveData="complianceRate" title="上月合规率" name="合规率" :color="sendColor" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 3' style="height:42.5%">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon6.png" alt="">
						<span>上月抽查率
							<!-- <strong>({{ spotCheckRate }}%)</strong> --></span>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: space-between;position:relative;'>
						<template v-for="(v, i) in spotCheckData">
							<div class="spot-child" :key="v.id" @click="jumpToPage('中粮集团',3)">
								<el-progress type="circle" :percentage="~~v.percent.split('/')[0]" :stroke-width="10" :color="v.percent.split('/')[1]"
								 :width="110"></el-progress>
								<span class="notes">抽查数量<br />（{{ v.num }}个）</span>
								<span class="spot-title">{{ v.name }}</span>
							</div>
						</template>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 4' style="height:42.5%">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon7.png" alt="">
						<span>上月相关方合规率</span>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: center;position:relative;'>
						<complianceChart :values="radarData" mark="%" :key="kk" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 5' style="height:48.5%;text-align:left;">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon5.png" alt="">
						<span>作业类别合规统计</span>
					</div>
					<div class="colContent work-statistics">
						<template v-for="(v, k) in workTypeData">
							<div class="work-child">
								<span>{{ k }}：{{ v }}%</span>
								<el-progress :stroke-width="12" :percentage="~~v" color="#74AEFB"></el-progress>
							</div>
						</template>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 6' style="height:500px">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon2.png" alt="">
						<span>上月问题统计</span>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: center;position:relative;'>
						<barChart1 :barData="workCategory" :descript="true" :legendState='true' @echartsClick='echartsClickTwo' />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 7' style="height:800px">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon9.png" alt="">
						<span>专业化公司合规率统计</span>
						<div class="check">
							<span class="checkItem checkRate" :class="{ 'checkActive2': classFlag }" @click="toggleRate">合规率</span>
							<span class="checkItem checkRate" :class="{ 'checkActive2': !classFlag }" @click="toggleRate">抽查率</span>
						</div>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: center;position:relative;'>
						<barChart1 :barData="newData" :descript="true" :legendState='true' legend="比率(%)" @echartsClick='ehcartsThree' />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 8' style="height:42.5%">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon15.png" alt="">
						<span>历史曲线</span>
						<div class="check">
<!--							<span class="checkItem checkActive" @click='checkState'>日</span>-->
							<span class="checkItem checkActive" @click='checkState'>月</span>
							<span class="checkItem" @click='checkState'>年</span>
						</div>
					</div>
					<div class="colContent">
						<curveChart :compliance="true" :curveData="workSituation" :descript='true' :legendSel='true' legend="比率(%)" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 9' style="height:500px">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon9.png" alt="">
						<span>作业类别合规统计</span>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: center;position:relative;'>
						<!-- <barChart1 :barData="companyStatistics" :descript="true" :legendState='true' legend="比率(%)" /> -->
						<barChart1 :key="aaaKey" :barData="workTypeData1" :descript="true" :legendState='true' legend="比率(%)"
						 @echartsClick='echartsClickFour' />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 10' style="height:400px">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon9.png" alt="">
						<span> 基层工厂合规率统计</span>
						<div class="check">
							<span class="checkItem checkRate" :class="{ 'checkActive1': classFlag }" @click="toggleRate">合规率</span>
							<span class="checkItem checkRate" :class="{ 'checkActive1': !classFlag }" @click="toggleRate">抽查率</span>
						</div>
					</div>
					<div class="colContent">
						<barChart1 :barData="newData" :descript="true" :legendState='true' legend="比率(%)" @echartsClick='ehcartsFive' />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-show='chartsState == 11' style="height:42.5%">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon6.png" alt="">
						<span>上月抽查率</span>
					</div>
					<div class="colContent" style='display:flex;align-items: center;justify-content: space-between;position:relative;'>
						<template v-for="(v, k) in spotCheckData1">
							<div class="spot-child">
								<el-progress type="circle" :percentage="~~v.split('/')[0]" :stroke-width="10" :color="v.split('/')[1]" :width="110"></el-progress>
								<span class="notes">{{ k }}</span>
							</div>
						</template>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<div class="colHeader">
						<img src="../../assets/images/icon2.png" alt="">
						<span>问题列表查询</span>
					</div>
					<div class="colContent search" style='height:calc(100% - 55px);padding-top:10px;'>
						<div class='inp'>
							<span>检查单位：</span>
							<div>
								<input type="text" v-model="getTable.checkDept">
							</div>
						</div>
						<div class='inp'>
							<span>检查人：</span>
							<div>
								<input type="text" v-model="getTable.checkPeople">
							</div>
						</div>
						<div class='inp'>
							<span>问题类型：</span>
							<div>
								<input type="text" v-model="getTable.issueType">
							</div>
						</div>
						<div class='inp'>
							<span>问题描述：</span>
							<div>
								<input type="text" v-model="getTable.checkIssue">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>作业类别：</span>
							<div>
								<input type="text" v-model="getTable.workClassify">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>作业级别：</span>
							<div>
								<input type="text" v-model="getTable.workLevel">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>作业种类：</span>
							<div>
								<input type="text" v-model="getTable.isRelation">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>合规类别：</span>
							<div>
								<input type="text" v-model="getTable.checkFlag">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>联系方式：</span>
							<div>
								<input type="text" v-model="getTable.checkPhone">
							</div>
						</div>
						<div class='inp' v-show='showAll'>
							<span>检查时间：</span>
							<div>
								<input type="text" v-model="getTable.checkTime">
							</div>
						</div>
						<div style='margin-top:10px;color:#bbb;'>
							<van-icon v-show='!showAll' name="arrow-down" @click="showAll = true" />
							<van-icon v-show='showAll' name="arrow-up" @click="showAll = false" />
						</div>
						<div style='margin-top:10px;'>
							<van-button type="primary" @click="search">查询</van-button>
							<van-button type="primary" @click="reset">重置</van-button>
						</div>
					</div>
				</div>
			</van-col>
			<div style='clear:both'>
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class='vant-clearfix' offset='0'
				 :immediate-check="false">
					<div class="elCol elColRow" v-for="(item,index) in listData" :key='index'>
						<!-- <div class="colHeader">
									<img v-if="item.ZYLB != '吊装作业'" src="../../assets/images/dangerWork/icon1.png" alt="">
									<img v-if="item.ZYLB == '动火作业'" src="../../assets/images/dangerWork/icon2.png" alt="">
									<img v-if="item.ZYLB == '动土作业'" src="../../assets/images/dangerWork/icon3.png" alt="">
									<img v-if="item.ZYLB == '断路作业'" src="../../assets/images/dangerWork/icon4.png" alt="">
									<img v-if="item.ZYLB == '高处作业'" src="../../assets/images/dangerWork/icon5.png" alt="">
									<img v-if="item.ZYLB == '检修作业'" src="../../assets/images/dangerWork/icon6.png" alt="">
									<img v-if="item.ZYLB == '盲板作业'" src="../../assets/images/dangerWork/icon7.png" alt="">
									<img v-if="item.ZYLB == '有限空间作业'" src="../../assets/images/dangerWork/icon8.png" alt="">
									<img v-if="item.ZYLB == '临时用电作业'" src="../../assets/images/dangerWork/icon9.png" alt="">
									<span>{{item.ZYLB}}</span>
									<span class='workState'>
										作业状态：<i>{{item.ZYZT}}</i>
									</span>
								</div> -->
						<div class="colContent" style='height:calc(100% - 55px);background:none;'>
							<ul class='dataUl'>
								<li>
									<span class='textTitle'><i class='circle'></i>检查单位:</span>
									<span class='textCon'>{{item.checkDept}}</span>
								</li>
								<li>
									<span class='textTitle'><i class='circle'></i>检查人:</span>
									<span class='textCon'>{{item.checkPeople}}</span>
								</li>
								<li>
									<span class='textTitle'><i class='circle'></i>问题类型:</span>
									<span class='textCon'>{{item.issueType}}</span>
								</li>
								<li>
									<span class='textTitle'><i class='circle'></i>问题描述:</span>
									<span class='textCon'>{{item.checkIssue}}</span>
								</li>
								<li v-show='false' :class="'lb'+index">
									<span class='textTitle'><i class='circle'></i>作业类别:</span>
									<span class='textCon'>{{item.workClassify}}</span>
								</li>
								<li v-show='false' :class="'jb'+index">
									<span class='textTitle'><i class='circle'></i>作业级别:</span>
									<span class='textCon'>{{item.workLevel}}</span>
								</li>
								<li v-show='false' :class="'zl'+index">
									<span class='textTitle'><i class='circle'></i>作业种类:</span>
									<span class='textCon'>{{item.isRelation}}</span>
								</li>
								<li v-show='false' :class="'hg'+index">
									<span class='textTitle'><i class='circle'></i>合规类别:</span>
									<span class='textCon'>{{item.checkFlag}}</span>
								</li>
								<li v-show='false' :class="'ks'+index">
									<span class='textTitle'><i class='circle'></i>联系方式:</span>
									<span class='textCon'>{{item.checkPhone}}</span>
								</li>
								<li v-show='false' :class="'js'+index">
									<span class='textTitle'><i class='circle'></i>检查时间:</span>
									<span class='textCon'>{{item.checkTime }}</span>
								</li>
                <li v-show='false' :class="'bh'+index">
                  <span class='textTitle'><i class='circle'></i>许可证编号:</span>
                  <span class='textCon'>{{item.workCode }}</span>
                </li>
								<li v-show='false' :class="'tp'+index" class="itemDetail">
									<span class='textTitle'><i class='circle'></i>图片上传:</span>
									<cUpload
										ref="cUpload"
										:preview="true"
										:isDel='false'
										uploadType="inspectionRecord"
										:uploadParentId="item.id"
										acceptFileType="jpg,jpeg,png,gif"
										:limitNum="5" limitSize="10M"/>
								</li>
								<li v-show='false' :class="'qz'+index">
									<span class='textTitle'><i class='circle'></i>检查人签字:</span>
									<img v-if="item.checkPeopleSignature" style='width:calc(100% - 115px);height:auto;'
										:src="item.checkPeopleSignature" alt='暂无图片'>
								</li>
								<li class='arrowLi'>
									<van-icon :class="'down'+index" name="arrow-down" @click="showDiv(index)" />
									<van-icon :class="'up'+index" v-show='false' name="arrow-up" @click="hiddenDiv(index)" />
								</li>
							</ul>
						</div>
					</div>
				</van-list>
			</div>
			<!-- <div id="wrap">
				<div id="home">
					<img :src="require('../../assets/images/add.png')" ref="addIcon" class="addIcon" @click="clickAddIcon" />
				</div>
			</div> -->
		</van-row>
		<div v-show="show" class="templateForm">
			<div class="formbox">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item style="width:100%;" prop="companyName">
              <van-row>
                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         专业化公司:
                   </van-col>
                   <van-col span="1"></van-col>
                   <van-col span="17"  style="">
                      <!-- <van-field
                       v-model="ruleForm.companyName"
                        :disabled="disabledCompanyName"
                       type="text"
                       placeholder="请输入专业化公司"
                     /> -->
										  <el-select
                      v-model="ruleForm.companyName"
                      placeholder="请选择专业公司"
                     :disabled="disabledCompanyName"
                      @change="changeCompany"
                      style="width:85%">
                      <el-option
                        v-for="item in ComList"
                        :key="item.qyName"
                        :label="item.qyName"
                        :value="item.qyName">
                      </el-option>
                      </el-select>
                       </van-col>

             </van-row>
             </el-form-item>
              <el-form-item style="width:100%;" prop="qyName" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         基层工厂:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" >
                      <el-select
                      v-model="ruleForm.qyName"
                      placeholder="请选择基层工厂"
                      :disabled="disabledGC"
                       @change="changeQy"
                      style="width:85%">
                      <el-option
                        v-for="item in qyNameList"
                        :key="item.qyName"
                        :label="item.qyName"
                        :value="item.qyName">
                      </el-option>
                      </el-select>
                  </van-col>

             </van-row>
              </el-form-item >
               <el-form-item style="width:100%;" prop="checkDept">
             <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         检查单位:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" >
                      <van-field
                       v-model="ruleForm.checkDept"
                       disabled
                       type="text"
                       placeholder="请输入检查单位"
                       :rules="[{ required: true, message: '请输入检查单位' }]"
                     />
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" prop="issueType">
             <van-row>

                <van-col span="6" style="text-align:right;">
                         问题类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select  v-model="ruleForm.issueType" style="width:85%" placeholder="请选择问题类别" :disabled="disabledState">
                   <el-option
                     v-for="item in issueTypeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" prop="workClassify">
             <van-row>

                <van-col span="6" style="text-align:right;">
                         作业类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.workClassify"
                   style="width:85%" placeholder="请选择作业类别"
                  >
                   <el-option
                     v-for="item in workClassifyList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" prop="workLevel">
             <van-row>

                <van-col span="6" style="text-align:right;">
                         作业级别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.workLevel"
                    style="width:85%"
                     placeholder="请选择作业级别"
                    >
                   <el-option
                     v-for="item in workLevelList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" prop="isRelation">
              <van-row>

                <van-col span="6" style="text-align:right;">
                         相关方作业:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.isRelation"
                    style="width:85%" placeholder="请选择作业种类"
                    >
                   <el-option
                     v-for="item in isRelationlList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" prop="workCode">
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                        作业编码:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" >
                       <el-input placeholder="请输入作业编码"
											 style="width:85%;"
                         v-model="ruleForm.workCode"
                         autocomplete="off"/>
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
             <van-row >

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         检查人:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" >
                     <van-field
                       style="text-align:right;"
                       v-model="ruleForm.checkPeople"
                       type="text"
                       :disabled="true"
                       placeholder="请输入检查人"
                       :rules="[{ required: true, message: '请输入检查人' }]"
                      />
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                        联系方式:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" >
                        <van-field
                        :disabled="true"
                          v-model="ruleForm.checkPhone"
                          type="text"
                          placeholder="请输入联系方式"
                          :rules="[{ required: true, message: '请输入联系方式' }]"
                        />
                  </van-col>

             </van-row>
              </el-form-item>
              <el-form-item prop="checkTime">
              <van-row>

                   <van-col span="6" style="text-align:right;">
                         检查时间:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17">
                           <!-- <cDataPicker  @changeValue="changeValue" v-model="ruleForm.checkTime"
					                 type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择时间"
					                 /> -->
                               <vDataPicker
                               @changeValue="changeValue"
                               :item="item"
                               style="width:85%"
                               :defaultValue="ruleForm.checkTime"
                               />
                   </van-col>

              </van-row>
            </el-form-item>
             <el-form-item style="width:100%;" prop="checkFlag">
              <van-row>

                <van-col span="6" style="text-align:right;">
                       合格类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select style="width:85%"  v-model="ruleForm.checkFlag" placeholder="请选择合格类别:" :disabled="disabledState">
                   <el-option
                     v-for="item in checkFlagList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

              </van-row>
               </el-form-item>
              <el-form-item style="width:100%;" prop="checkIssue">
              <van-row>

                <van-col span="6" style="text-align:right;margin-top:8px;">
                    问题描述:
                </van-col>
                  <van-col span="1"  >
                  </van-col>
                 <van-col span="17" >
                  <el-input
                   style="width:85%;"
                   v-model="ruleForm.checkIssue"
                   type="textarea"
                   :disabled="disabledState "
                   :rows="4"></el-input>
                </van-col>

              </van-row>
               </el-form-item>
              <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="7" style="text-align:right;">
                    图片上传：
                </van-col>
                 <!-- <van-col span="1">
                </van-col> -->
                 <van-col span="17">
                      <cUpload  ref="cUpload" v-if="!disabledState" :preview="true" @uploadFiles="uploadFiles" uploadType="inspectionRecord" :uploadParentId="ruleForm.id" acceptFileType="jpg,jpeg,png,gif" :limitNum="5" limitSize="10M"/>
                      <cPhotoWall v-else :photoList="photoList"/>
                </van-col>

              </van-row>
               </el-form-item>
                <el-form-item style="width:100%;" prop="checkPeopleSignature">
               <van-row>

                <van-col span="7" style="text-align:right;">
                    检查人签字：
                </van-col>
                 <!-- <van-col span="1" >
                  </van-col> -->
                 <van-col span="17">
                  <!-- <van-button type="info" @click="writeClick"
                    >点击签字</van-button> -->
                  <el-button type="primary" @click="writeClick">点击签字</el-button>
                </van-col>
                  <!-- <van-popup
                  v-model="show1"
                  position="bottom"
                  closeable
                  :style="{ height: '41%' }"
                >
                <van-cell >
                  <cSignCanvas
                       class="canvascell"
                       :id="ruleForm.checkPeopleSignature"
                       @clearwrite="clearwrite"
                       @addSignFile="addSignFile"
                       ref="cSignCanvas"
                    />
                </van-cell>
               </van-popup> -->
              </van-row>
               </el-form-item>
           <el-form-item style="width:100%;" >
              <div class="topBar">
                <van-row>
                  <van-col :span="24" style="text-align: center">
                    <p @click="submitForm('ruleForm')">保存</p>
                  </van-col>
                </van-row>
              </div>
           </el-form-item>
          </el-form>
		</div>
		 <el-dialog title="检查人签字"
     center
     width="100%"
     top="100%"
     custom-class="inspectionRecordBody1"
     :append-to-body="true"
    :visible.sync="show1">
        <cSignCanvas
                       class="canvascell"
                       :id="ruleForm.checkPeopleSignature"
                       @clearwrite="clearwrite"
                       @addSignFile="addSignFile"
                       ref="cSignCanvas"
                    />
    </el-dialog>
		</div>
	</div>
</template>

<script>
	//import echarts from "echarts";
	import barChart1 from "../echarts/barChart1";
	import curveChart from "../echarts/curveChart";
	import annularChart from "../echarts/annularChart";
	import chartSpe from "../echarts/chartSpe";
	import pieChart from "../echarts/pieChart";
	import complianceChart from '../echarts/circleChart'
	import radarChart from "../echarts/radarChart"
	import gaugeChart from "../echarts/gaugeChart"
	import axios from 'axios'
	import cSignCanvas from "../element/c-signCanvas";
	import cDataPicker from "../element/c-data-picker"
	import cUpload from '../element/c-upload'
	import cPhotoWall from '../element/c-photoWall'
	import vDataPicker from "../vant/v-data-picker"
	export default {
		name: 'rateInfo',
		props: {},
		data() {
			return {
				kk: 0,
				photoList: [],
				show: false,
				show1: false,
				qyNameList:[],
				ComList:[],
				ruleForm: {
					"id": "",
					"companyName": "", //专业化公司
					"companyId": '',
					"qyName": "", //工厂
					"qyId": '',
					"issueType": "", //问题类别
					"workid": "", //作业id
					"checkImg": "",
					"checkPeople": "", //巡检人
					"checkPhone": "",
					"checkTime": "", //巡检时间
					"passScore": '', //合规评分
					"checkIssue": "", //问题描述
					"checkPeopleSignature": "", //巡检人签字
					"checkDept": "", //检查单位
					"workClassify": "", //作业类别
					"workCode": "", //作业编码
					"workLevel": "", //作业级别
					"isRelation": "", //作业种类
					"checkFlag":"",//合规类别

				},
				 rules: {
          companyName: [
            { required: true, message: '请选择专业化公司', trigger: 'change' }
          ],
          qyName: [
            { required: true, message: '请选择基层工厂', trigger: 'change' }
          ],
          workClassify: [
            { required: true, message: '请选择作业类别', trigger: 'change' }
          ],
          workLevel: [
            { required: true, message: '请选择作业级别', trigger: 'change' }
          ],
          isRelation:[
             { required: true, message: '请选择作业种类', trigger: 'change' }
          ],
          workCode:[
             { required: true, message: '请填写作业编码', trigger: 'change' }
          ],
          checkTime: [
            { required: true, message: '请选择时间', trigger: 'change' }
          ],
          checkFlag: [
            { required: true, message: '请选择合规类别', trigger: 'change' }
          ],
          checkIssue:[
             { required: true, message: '请填写问题描述', trigger: 'change' }
          ],
          checkPeopleSignature:[
             { required: true, message: '请签字', trigger: 'change' }
          ]
        },
				item: {
					titleName: "检查时间"
				},
				aaaKey: 0,
				radarData: {
					one: 0,
					two: 0,
					three: 0
				},
				disabledState: false,
				signId: "", //图片id
				issueTypeList: [{
						value: '五必须',
						label: '五必须'
					}, {
						value: '信息的真实性',
						label: '信息的真实性'
					}, {
						value: '违章作业',
						label: '违章作业'
					}, {
						value: '劳动组织',
						label: '劳动组织'
					}, {
						value: '风险管控',
						label: '风险管控'
					},
					{
						value: '提级管理',
						label: '提级管理'
					}, {
						value: '变更管理',
						label: '变更管理'
					}, {
            value: '视频抽查',
            label: '视频抽查'
          }, {
						value: '其他',
						label: '其他'
					},
				],
				checkFlagList: [{
						value: '重大不合规',
						label: '重大不合规'
					},
					{
						value: '一般不合规',
						label: '一般不合规'
					},
					{
						value: '合规',
						label: '合规'
					},
				],
				isRelationlList: [ {
            value: '无',
            label: '无'
           },
           {
             value: '甲类',
             label: '甲类'
           },
           {
            value: '乙类',
            label: '乙类'
           },
           {
             value: '丙类',
             label: '丙类'
           },
				],
				workLevelList: [{
						value: '一般危险',
						label: '一般危险'
					},
					{
						value: '较大危险',
						label: '较大危险'
					},
					{
						value: '高度危险',
						label: '高度危险'
					},
				],
				workClassifyList: [{
						value: '动火作业',
						label: '动火作业'
					},
					{
						value: '有限空间作业',
						label: '有限空间作业'
					},
					{
						value: '高处作业',
						label: '高处作业'
					},
					{
						value: '临时用电作业',
						label: '临时用电作业'
					},
				],
				radarLegend: ['甲类', '乙类', '丙类'], //上月相关方合规率
				complianceRate: null, // 合规率总百分比
				sendColor: [
					[0.25, '#DC143C'],
					[0.5, '#FF7859'],
					[0.75, '#FFC63C'],
					[1, '#74AEFB']
				], // 仪表盘接受颜色
				spotCheckRate: '0', // 抽查率总百分比
				spotCheckRate1: '0', // 抽查率总百分比
				spotCheckDataTemp: {},
				showAll: false,
				name: this.$route.params.name,
				gcName: this.$route.params.gcName,
				chartsState: this.$route.params.state,
        changeFlag: this.$route.params.changeFlag,
        type: this.$route.params.type,
        centerText: this.$route.params.rateName || sessionStorage.getItem('rateName'),
				factoryName: sessionStorage.getItem('GCMZ'),
				info: {
					num: '0'
				},
				typeList: {},
				loading: false,
				finished: false,
				getTable: {
					ZYHGSID: "", //专业化公司ID
					ZYHGSMZ: '',
					GCMZ: '',
					limit: 10,
					page: 1,
					checkPeople: '',
					issueType: this.$route.params.issueType,
					checkIssue: '',
					//passScore: '',
					//assessmentScore: '',
					workLevel: '', //危险级别
					workClassify: '', //危险类别
					isRelation: '',
					checkFlag: '',
				},
				count: 0,
				listData: [],
				//合规率
				spotCheckData: {}, // 抽查率数据
				spotCheckData1: {}, // 抽查率数据
				workTypeData: {}, // 作业类别合规统计数据
				workTypeData1: {},
				workCategory: {}, // 问题统计
				companyStatistics: {}, // 专业化公司合规率统计
				relatedParty: {
					'企业作业': 0,
					'相关方作业': 0
				}, // 相关方合规率
				//AssessList: [], // 评价
				//AssessListvalue1: '',
				//AssessListvalue2: '',
				//AssessListvalue3: '',
				workSituation: {
					'合规率': {
						'1月': 10,
						'2月': 12,
						'3月': 15,
						'4月': 16,
						'5月': 11,
						'6月': 20,
						'7月': 21,
						'8月': 22,
						'9月': 25,
						'10月': 45,
						'11月': 30,
						'12月': 15,
					},
					'抽查率': {
						'1月': 20,
						'2月': 22,
						'3月': 25,
						'4月': 26,
						'5月': 21,
						'6月': 40,
						'7月': 31,
						'8月': 32,
						'9月': 35,
						'10月': 25,
						'11月': 30,
						'12月': 25,
					}
				}, // 历史曲线
				newData: {},
				classFlag: true, // 类名切换
				disabledCompanyName:false,
				disabledGC:false,
			}
		},

		components: {
			chartSpe,
			curveChart,
			annularChart,
			pieChart,
			complianceChart,
			radarChart,
			barChart1,
			gaugeChart,
			cSignCanvas,
			cDataPicker,
			cPhotoWall,
			cUpload,
			vDataPicker
		},

		created() {
			this.loadCompliance();
			this.loadSpotCheck();
			this.loadSpotCheck1();
			this.loadWorkType();
			this.loadWorkType1();
			this.initWorkCategory();
			this.initCompanyData();
			//this.getAssessList();
			this.xgfloadCompliance();
			this.complianceStatistics();
			this.getGhlNum('selectPollingByMonth', '月')
		},

		mounted() {
			//this.getData();
			this.getWorkPolling();
			let userInfo = sessionStorage.getItem("userInfo")
			userInfo = JSON.parse(userInfo)
			// this.ruleForm = JSON.parse(JSON.stringify(this.rulu))
			this.ruleForm.checkDept = userInfo.qyname
			this.itemid = this.$route.params.id || sessionStorage.getItem('inspectionRecordID')
			sessionStorage.setItem('inspectionRecordID', this.itemid)
		},

		watch: {

		},

		methods: {
			 submitForm(formName,code) {
        this.$refs[formName].validate((valid)=>{
          if (valid) {
            this.commit();
          } else {
            return false;
          }
        });
      },
			//上拉加载更多数据
			onLoad() {
				this.getTable.page++
				this.getWorkPolling()
			},
			search() {
				this.getTable.page = 1
				this.listData = [];
				this.getWorkPolling()
			},
			//重置
			reset() {
				this.getTable = {
					ZYHGSID: "", //专业化公司ID
					ZYHGSMZ: '',
					GCMZ: '',
					startTime: '',
					endTime: '',
					ZYLB: "", //作业类别
					ZYJB: "", //作业级别
					ZYNR: "", //作业内容
					ZYZT: "", //作业类别
					serchTime: '',
					limit: 10,
					page: 1,
					checkPeople: '',
					issueType: '',
					checkIssue: '',
					passScore: '',
					assessmentScore: '',
					workLevel: '',
				}
			},

			getWorkPolling() {
				if (this.name) {
					this.getTable.companyName = this.name
				}
				if (this.gcName) {
					this.getTable.qyName = this.gcName
				}
				this.getTable.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/list', this.getTable).then((res) => {
					if (res.data.code) {
						this.loading = false
						this.count = res.data.data.total;
						let rows = res.data.data.rows;
						if (rows == null || rows.length === 0) {
							// 加载结束
							this.finished = true;
							return;
						}
						if (rows.length < this.getTable.limit) {
							// 最后一页不足10条的情况
							this.finished = true;
						}
						if (this.getTable.page === 1) {
							this.listData = rows
						} else {
							// 将新数据与老数据进行合并
							this.listData = this.listData.concat(rows);
						}
						if (this.listData.length >= this.count) {
							this.finished = true;
						}
					}
				})
			},
			goBack() {
				this.$router.go(-1)
			},
			//获取企业详情数据
			getData() {
				let obj = {
					lastmonth:'yes'
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/getIssueInfo', obj)
					.then((res) => {
						if (res.data.code) {
							let data = res.data.data
							this.typeList = [];
							for (let k in data.typeInfo) {
								let tyin = {
									name: k,
									value: data.typeInfo[k]
								}
								this.typeList.push(tyin);
							}
							for (let k in data.numInfo) {
								if (k == '总量') {
									this.info.num = data.numInfo[k]
								} else if (k == '合规率') {
									this.info.num1 = data.numInfo[k]
								} else if (k == '不合规') {
									this.info.num2 = data.numInfo[k]
								}
							}
						}
					})
			},
			//查询结果点击下拉箭头的事件
			showDiv(num) {
				document.getElementsByClassName('ks' + num)[0].style.display = 'flex'
				document.getElementsByClassName('js' + num)[0].style.display = 'flex'
				document.getElementsByClassName('jb' + num)[0].style.display = 'flex'
				document.getElementsByClassName('lb' + num)[0].style.display = 'flex'
				document.getElementsByClassName('tp' + num)[0].style.display = 'flex'
				document.getElementsByClassName('qz' + num)[0].style.display = 'flex'
				document.getElementsByClassName('zl' + num)[0].style.display = 'flex'
				document.getElementsByClassName('hg' + num)[0].style.display = 'flex'
        document.getElementsByClassName('bh' + num)[0].style.display = 'flex'
        document.getElementsByClassName('down' + num)[0].style.display = 'none'
				document.getElementsByClassName('up' + num)[0].style.display = 'flex'

			},
			hiddenDiv(num) { //收起
				document.getElementsByClassName('ks' + num)[0].style.display = 'none'
				document.getElementsByClassName('js' + num)[0].style.display = 'none'
				document.getElementsByClassName('jb' + num)[0].style.display = 'none'
				document.getElementsByClassName('lb' + num)[0].style.display = 'none'
				document.getElementsByClassName('tp' + num)[0].style.display = 'none'
				document.getElementsByClassName('qz' + num)[0].style.display = 'none'
				document.getElementsByClassName('zl' + num)[0].style.display = 'none'
				document.getElementsByClassName('hg' + num)[0].style.display = 'none'
        document.getElementsByClassName('bh' + num)[0].style.display = 'none'
        document.getElementsByClassName('down' + num)[0].style.display = 'block'
				document.getElementsByClassName('up' + num)[0].style.display = 'none'
			},
			//
			echartsClickOne(params) {
				this.getTable.workLevel = params
				this.search()
			},
			//问题描述统计图表格联动
			echartsClickTwo(params) {
				this.getTable.issueType = params
				this.search()
			},
			ehcartsThree(params) {
				this.getTable.companyName = params
				this.search()
			},
			echartsClickFour(params) {
				this.getTable.workClassify = params
				this.search()
			},
			ehcartsFive(params) {
				this.getTable.qyName = params
				this.search()
			},

			// 合规率数据后台获取
			loadCompliance() {
				let _that = this
				let obj = {
					qyName: '',
					companyName: '',
					lastmonth :'yes'
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        obj.lastmonth = 'yes'
        let onlyzyh = "";
        if (sessionStorage.getItem("GCMZ")) {
          onlyzyh = "factory";
        } else if (sessionStorage.getItem("ZYHGSMZ")) {
          onlyzyh = "company";
        } else {
          onlyzyh = "group";
        }
        obj.onlyzyh = onlyzyh
        this.$axios.post('/dform/workPolling/passListNew', obj)
					.then((res) => {
						if (res.data.code) {
							//_that.complianceData = res.data.data.data
							_that.complianceRate = res.data.data.sum;
						}
					})
			},
			// 相关方合规率数据后台获取
			xgfloadCompliance() {
				let _that = this
				let obj = {
					qyName: '',
					companyName: '',
					lastmonth :'yes'
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        obj.isRelation = "yes"

        let onlyzyh = "";
        if (sessionStorage.getItem("GCMZ")) {
          onlyzyh = "factory";
        } else if (sessionStorage.getItem("ZYHGSMZ")) {
          onlyzyh = "yes";
        } else {
          onlyzyh = "jituan";
        }
        obj.onlyzyh = onlyzyh
            this.$axios.post('/dform/workPolling/XgfListNew', obj)
					.then((res) => {
						if (res.data.code === 1) {
							_that.radarData.one = Number(res.data.data.data.a)
							_that.radarData.two = Number(res.data.data.data.b)
							_that.radarData.three = Number(res.data.data.data.c)
							_that.kk++
						}
					})
			},

			// 抽查率数据后台获取
			loadSpotCheck() {
				let _that = this;
				let obj = {
					qyName: '',
					companyName: '',
					lastmonth:'yes'
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/checkListGroup', obj)
					.then((res) => {
						if (res.data.code === 1) {
							_that.spotCheckData = res.data.data.data;
							_that.spotCheckRate = res.data.data.sum;
							for (let i in _that.spotCheckData) {
								switch (i) {
									case "0":
										this.spotCheckData[i].percent += "/#74AEFB";
										break;
									case "1":
										this.spotCheckData[i].percent += "/#FFC63C";
										break;
									case "2":
										this.spotCheckData[i].percent += "/#FF7859";
										break;
								}
							}
						}
					})
			},
			// 抽查率数据后台获取
			loadSpotCheck1() {
				let _that = this
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.centerText) {
					obj.companyName = this.centerText
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/checkList', obj)
					.then((res) => {
						if (res.data.code === 1) {
							this.spotCheckData1 = res.data.data.data;
							for (let i in this.spotCheckData1) {
								switch (i) {
									case "一般危险":
										this.spotCheckData1[i] += "/#74AEFB";
										break;
									case "较大危险":
										this.spotCheckData1[i] += "/#FFC63C";
										break;
									case "高度危险":
										this.spotCheckData1[i] += "/#FF7859";
										break;
								}
							}
						}
					})
			},

			// 基层工厂作业类别合规统计数据获取
			loadWorkType() {
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.name) {
					obj.companyName = this.companyName
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				let onlyzyh = "";
				if (sessionStorage.getItem("GCMZ")) {
				onlyzyh = "factory";
				} else if (sessionStorage.getItem("ZYHGSMZ")) {
				onlyzyh = "yes";
				} else {
				onlyzyh = "jituan";
				}
				obj.onlyzyh = onlyzyh
				if(onlyzyh == "factory" && obj.qyName){
					obj.companyName = ''
				}
				obj.lastmonth = "yes";
				obj.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/passTypeList', obj).then((res) => {
					if (res.data.code === 1) {
						this.workTypeData1['百分比'] = res.data.data;
						this.aaaKey++
					}
				})
			},
			// 作业类别合规统计数据获取
			loadWorkType1() {
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
				this.$axios.post('/dform/workPolling/passTypeList', obj).then((res) => {
					if (res.data.code === 1) {
						this.workTypeData = res.data.data;
					}
				})
			},

			// 合规率首页列表初始化
			/* initGrid() {
				this.$axios.post('/dform/workPolling/selectIssueList', this.getTable).then((res) => {
					if (res.data.code === 1) {
						this.workTypeData = res.data.data;
					}
				})
			}, */

			// 十大问题统计统计图数据修改
			initWorkCategory() {
        let onlyzyh = "";
        if (sessionStorage.getItem("GCMZ")) {
          onlyzyh = "factory";
        } else if (sessionStorage.getItem("ZYHGSMZ")) {
          onlyzyh = "company";
        } else {
          onlyzyh = "group";
        }
				let _that=this
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.name) {
					obj.companyName =this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        obj.lastmonth='yes'
        obj.onlyzyh = onlyzyh
        this.$axios.post('/dform/workPolling/issueList', obj)
					.then((res) => {
						if (res.data.code === 1) {
							_that.workCategory = res.data.data;
						}
					})
			},

			// 专业化公司合规率统计
			initCompanyData() {
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        if (this.type === "group") {
          obj.onlyzyh = 'jituan'
          obj.lastmonth = 'yes'
        }else if(this.type === "company"){
          obj.onlyzyh = 'yes'
          obj.lastmonth = 'yes'
        }
				this.$axios.post('/dform/workPolling/passQYList', obj)
					.then((res) => {
						if (res.data.code === 1) {
							this.companyStatistics = res.data.data;
							this.newData = { ...this.companyStatistics
							};
						}
					})
			},

			// 专业化公司合规率统计抽查率
			complianceStatistics() {
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.name) {
					obj.companyName = this.name
				}
				if (this.gcName) {
					obj.qyName = this.gcName
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        if (this.type === "group") {
          obj.onlyzyh = 'jituan'
          obj.lastmonth = 'yes'
        }else if(this.type === "company"){
          obj.onlyzyh = 'yes'
          obj.lastmonth = 'yes'
        }
				this.$axios.post('/dform/workPolling/checkQYList', obj)
					.then((res) => {
						if (res.data.code === 1) {
							this.spotCheckDataTemp = res.data.data;
						}
					})
			},

			// 评级
			// getAssessList() {
			// 	let obj = {
			// 		qyName: '',
			// 		companyName: ''
			// 	}
			// 	if (this.name) {
			// 		obj.companyName = this.name
			// 	}
			// 	if (this.gcName) {
			// 		obj.qyName = this.gcName
			// 	}
			// 	this.$axios.post('dform/workPolling/assessList', obj)
			// 		.then((res) => {
			// 			if (res.data.code === 1) {
			// 				this.AssessList = res.data.data;
			// 				this.AssessListvalue1 = this.AssessList[2].name;
			// 				this.AssessListvalue2 = this.AssessList[1].name;
			// 				this.AssessListvalue3 = this.AssessList[0].name;
			// 			}
			// 		})
			// },

			//历史曲线
			checkState(params) {
				if (params.target.className.indexOf("checkActive") == -1) {
					document.querySelector('span.checkItem.checkActive').classList.toggle('checkActive')
					params.target.setAttribute("class", 'checkItem checkActive');
					if (params.target.innerText == '日') {
						this.getGhlNum('selectPollingByDay', '日')
					} else if (params.target.innerText == '月') {
						this.getGhlNum('selectPollingByMonth', '月')
					} else if (params.target.innerText == '年') {
						this.getGhlNum('selectPollingByYear', '年')
					}
				}
			},
			getGhlNum(url, type) {
				let _that = this
				let obj = {
					qyName: '',
					companyName: ''
				}
				if (this.centerText) {
					obj.companyName = this.centerText
				}
				obj.cyllx=sessionStorage.getItem("rootDept")
        obj.onlyzyh = this.type
        obj.qyName  = this.factoryName
				this.$axios.post('/dform/workPolling/' + url, obj).then((res) => {
					_that.workSituation['合规率'] = res.data.data.hgl
					_that.workSituation['抽查率'] = res.data.data.ccl
				})
			},

			// 企业化公司合规率统计合规率抽查率切换
			toggleRate() {
				this.isCompliance = false;
				this.classFlag = !this.classFlag;
				if (this.classFlag) this.newData = { ...this.companyStatistics
				};
				else this.newData = { ...this.spotCheckDataTemp
				};
				this.$nextTick(() => {
					this.isCompliance = true;
				})
			},

			changeValue(val) {
         this.ruleForm.checkTime=val.value;
			},
			selectOper(val) {
				this.multipleSelection = val
			},
			writeClick() {
				this.show1 = true;
			},
			uploadFiles(params) {},
			clickAddIcon() {
				this.show = true;
			let loginFlag=sessionStorage.getItem('loginFlag');
				let userInfo = sessionStorage.getItem("userInfo")
				userInfo = JSON.parse(userInfo)
			//集团用户
			if(loginFlag=='2'){
       	this.disabledCompanyName=false;
				this.disabledGC=false;
				let qyName=userInfo.qyname;
				this.getComList(qyName)
			}
			if(loginFlag=='3'){//工厂
       			this.disabledCompanyName=true;
				this.disabledGC=true;
				this.ruleForm.qyName = userInfo.qyname
				this.ruleForm.qyId = userInfo.qyId
				this.ruleForm.companyName = userInfo.suborganizationName
        		this.ruleForm.companyId = userInfo.suborganization
			}
			if(loginFlag=='5'){//公司
       			this.disabledCompanyName=true;
				this.disabledGC=false;
				this.ruleForm.companyName = userInfo.qyname
				this.ruleForm.companyId = userInfo.qyId
				this.ComBlur(this.ruleForm.companyName)
			}
				this.$set(this.ruleForm, 'id', this.common.uuid())
				this.ruleForm.checkDept = userInfo.qyname
				//this.ruleForm.checkPeople = sessionStorage.getItem('userInfo').realName
				let loginUser = sessionStorage.getItem('loginUser')
				//let loginUser = sessionStorage.getItem('userInfo')
				loginUser = JSON.parse(loginUser)
				this.ruleForm.checkPeople = loginUser.loginName;
				this.ruleForm.checkPhone = loginUser.phoneNum;
			},
			   ComBlur(value){
          let obj={}
					obj.qyName=value
          this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
            let arr=JSON.parse(JSON.stringify(res.data.data[0].nodes))
            let arr2=[]
            this.qyNameList=arr;
            }
          })
      },
			ComBlur1(){

			},
			getComList(qyName){
          let obj={}
          obj.qyName =qyName;
          this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
            let arr=JSON.parse(JSON.stringify(res.data.data[0].nodes))
            let arr2=[]
            this.ComList=arr;
            }
          })
      },
		  changeCompany(value){
        this.ruleForm.companyName=value;
        let obj={}
        obj.qyName=value;
        this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
             this.ruleForm.companyId=res.data.data[0].qyId;
            }
					})
				this.ComBlur(value)
      },
			changeQy(value){
        this.ruleForm.qyName=value;
        let obj={}
        obj.qyName=value;
        this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
              this.ruleForm.qyId=res.data.data[0].qyId;
            }
          })
      },
			clearwrite(id) {
				let _that = this;
				axios({
						method: "post", //请求类型
						url: "/mongodb/deleteMongodFileById?fileId=" + id, //,//请求地址,端口号
						//headers:{"Content-Type":"multipart/form-data;"}//自定义请求头
					})
					.then((res) => {
						if (res.data.code) {
							_that.$message({
								type: "success",
								message: "签字删除成功",
							});
							// _that.tableData[_that.itemParams.index][_that.itemParams.modelName] = ''
							_that.signId = "";
							//清除表格对应签字
						}
					})
					.catch((err) => {
						_that.$message({
							type: "error",
							message: err,
						});
					});
			},
			async commit() {
				let _that = this
				await this.$refs.cUpload.$refs.cUpload.submit()
				this.ruleForm.workid = this.itemid
				this.$axios.post('/dform/workPolling/saveWorkPolling', this.ruleForm)
					.then((res) => {
						if (res.data.code) {
							_that.inspectionState = false
							_that.show = false;
							this.getWorkPolling(this.itemid);
							_that.$message({
								type: 'success',
								message: "添加成功",
							})
							_that.show = false;
							this.getWorkPolling();
						}
					})
			},
			async addSignFile(formdata) {
				let _that = this
				let url = ''
				//////
				await axios({
					method: 'post', //请求类型
					url: '/mongodb/uploadFile', //,//请求地址,端口号
					data: formdata, //request body
				}).then((res) => {
					if (res.data.code === 1) {
						_that.ruleForm.checkPeopleSignature = res.data.data
						_that.$message({
							type: 'success',
							message: "文件上传成功",
						})
						_that.show1 = false;
					}
				}).catch((err) => {
					_that.$message({
						type: 'error',
						message: err,
					})
				})
			},
		},

		computed: {

		},
	}
</script>

<style scoped>
	.itemDetail >>> .upload-demo span:last-child{
		margin-left: 0;
	}
	.itemDetail div,
	.van-swipe-cell__wrapper .imgBox div,
	.imgBox >>> .el-row,
	.imgBox >>> .el-col{
	margin-bottom: 0!important;
	}
	.itemDetail >>> .upload-demo .el-upload--picture-card{
	display: none;
	}
	.danger {
		position: relative;
	}

	.elColRow {
		width: 98%;
		margin-left: 1%;
		border-radius: 5px;
		height: auto;
		background: #fff;
		padding: 10px;
		text-align: center;
	}

	.elCol {
		margin-bottom: 5px;
		height: 42.5%;
	}

	.typeBox,
	.stateBox {
		padding: 0 5px 8px;
	}

	.typeBox .num {
		color: #74aefb;
	}

	.stateBox .num {
		color: #ffc63c;
	}

	.typeBox div,
	.stateBox div {
		height: 70px;
		background: #f1f7ff;
		border-radius: 5px;
		padding-top: 10px;
	}

	.stateBox div {
		background: #fff9eb;
	}

	.elCol .num {
		font-size: 17px;
		font-weight: bold;
	}

	.elCol span:nth-of-type(2) {
		font-size: 13px;
		display: block;
		margin-top: 8px;
	}

	.num1 {
		color: #55dbb1;
	}

	.num2 {
		color: #eb6100;
	}

	.num3 {
		color: #fec42c;
	}

	.num4 {
		color: #74aefb;
	}

	.navShow {
		/* background: linear-gradient(45deg, #46b6e9, #05469c); */
		width: 100%;
		height: 1.25rem;
		line-height: 1.25rem;
		z-index: 1;
	}

	.navShow .van-row {
		height: 100%;
	}

	.navShow .van-row .van-col {
		height: 100%;
		text-align: center;
		color: #fff;
		font-size: 0.45rem;
		/* font-weight: bold; */
	}

	.logo img {
		width: auto;
		height: 70%;
		position: relative;
		top: 20%;
	}

	.text {
		position: absolute;
		text-align: center;
	}

	.elRow {
		height: calc(100% - 45px);
		width: 100%;
		overflow-y: auto;
	}

	.elCol {
		margin-bottom: 5px;
		height: auto;
		background: #fff;
		padding: 10px;
		text-align: center;
	}

	.colBox {
		background: #fff;
		height: 100%;
	}

	.colHeader {
		height: 30px;
		line-height: 30px;
		display: flex;
		align-items: center;
		position: relative;
	}

	.colHeader strong {
		color: red;
	}

	.colHeader img {
		width: 25px;
		height: auto;
		margin-right: 8px;
	}

	.colHeader .more {
		font-size: 12px;
		position: absolute;
		right: 10px;
	}

	.colContent {
		height: calc(100% - 30px);
		background: #fff;
		margin: 10px 0 5px;
		overflow: hidden;
	}

	.sect-child {
		width: 50%;
		height: 100%;
		display: inline-block;
	}

	.dataUl li {
		display: flex;
		padding: 5px;
	}

	.dataUl li .textTitle {
		display: inline-block;
		width: 105px;
		color: #646566;
		font-size: 14px;
		line-height: 24px;
		text-align: left;
	}

	.dataUl li .textCon {
		display: inline-block;
		width: calc(100% - 115px);
		color: #323233;
		font-size: 14px;
		line-height: 24px;
		text-align: left;
		margin-top: 0;
	}

	.dataUl .arrowLi {
		justify-content: center;
		color: #bbb;
		padding: 0;
	}

	.search>div {
		width: 90%;
		margin: 0 auto 6px;
	}

	.search .inp>span {
		display: inline-block;
		width: 100px;
		text-align: left;
		font-size: 14px;
	}

	.search .inp>div {
		display: inline-block;
		width: calc(100% - 110px);
	}

	.search input {
		width: 100%;
		padding: 5px 8px;
		border-radius: 4px;
		border: 1px solid #ddd;
	}

	.search .van-button {
		width: 90px;
		height: 40px;
		line-height: 40px;
		margin: 0 15px;
		/* background: linear-gradient(45deg, #46b6e9, #05469c); */
		border: none;
	}

	.colContent>>>.spot-child {
		position: relative;
	}

	.colContent>>>.spot-child {
		position: relative;
	}

	.colContent>>>.el-progress--circle .el-progress__text,
	.colContent>>>.el-progress--dashboard .el-progress__text {
		top: 40%;
	}

	.colContent>>>.spot-child .el-progress__text {
		font-size: 18px !important;
	}

	.colContent>>>.spot-child:first-child .el-progress__text {
		color: #74AEFB;
	}

	.colContent>>>.spot-child:nth-child(2) .el-progress__text {
		color: #FFC63C;
	}

	.colContent>>>.spot-child:last-child .el-progress__text {
		color: #FF7859;
	}

	.notes {
		position: absolute;
		bottom: 35%;
		left: 28%;
	}

	.work-statistics {
		width: 96%;
		margin-left: 4%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.work-statistics .work-child {
		width: 50%;
		margin-top: 10px;
	}

	.work-statistics .work-child>>>.el-progress__text {
		display: none;
	}

	.work-statistics .work-child>>>.el-progress-bar {
		padding-right: 24px;
	}

	#wrap {
		position: fixed;
		right: 28px;
		bottom: 60px;
		width: 1.1rem;
		height: 1.1rem;
	}

	/* #home {
		position: absolute;
		width: 1.1rem;
		height: 1.1rem;
		background-repeat: no-repeat;
		z-index: 5;
		border-radius: 50%;
		transition: 0.5s;
	} */

	.addIcon {
		width: 1.1rem;
		height: 1.1rem;
		transition: transform 0.75s;
	}

	.templateForm {
		width: 100%;
		height: 100%;
		/* display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center; */
		background-color: #e1eef6;
		overflow-y: scroll;
		position: relative;
	}

	.templateForm {
		width: 100%;
		height: 100%;
		/* display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center; */
		background-color: #e1eef6;
		overflow-y: scroll;
		position: relative;
	}

	.writediv {
		display: flex;
		justify-content: start;
		align-items: center;
	}

	.writediv button {
		width: 100px;
		height: 30px;
		border-radius: 30px;
		/* display:inline-block; */
		text-align: left;
		margin-left: 50px;
	}

	.formbox {
		width: 100%;
		height: 90%;
		background-color: #fff;
		overflow-y: scroll;
		position: relative;
		margin-bottom: 20px;
	}

	.topBar {
		height: 1.2rem;
		/* background: linear-gradient(90deg, #3eb2e7, #05469c); */
		color: #fff;
		font-size: 0.5rem;
		line-height: 1.2rem;
		position: fixed;
		bottom: 0;
		width: 100%;
		left: 0;
		margin-top: 20px;
	}

	.topBar p {
		display: inline;
	}

	.topBarImg {
		height: 0.5rem;
		line-height: 1.2rem;
		font-weight: bold;
	}

	.bottomBar {
		height: 1rem;
	}

	.bottomBar .el-button {
		width: 100%;
		background-color: #384c9b;
		color: #fff;
		font-size: 0.25rem;
	}

	.cancel {
		background-color: #2f2;
	}

	.delete {
		background-color: #f22;
	}

	.van-popup {
		padding: 30px 20px;
	}

	.canvascell {
		height: 100%;
	}

	.check {
		border: 1px solid #eee;
		box-sizing: border-box;
		float: right;
		position: absolute;
		top: 0;
		right: 6px;
		display: inline-block;
		height: 22px;
		line-height: 20px;
		z-index: 100;
		font-size: 14px;
	}

	.check .checkItem {
		text-align: center;
		display: inline-block !important;
		margin-top: 0 !important;
		padding: 0 6px;
	}

	.check .checkActive,
	.checkActive1,
	.checkActive2 {
		background: #EB6100;
		color: #fff;
	}
</style>
